import _slicedToArray from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useAuthentication } from './useAuthentication';
import { AnonymousIdentity } from '../auth/Identity';
import { useCallback, useEffect, useState } from 'react';

function mapUser(user) {
  return user instanceof AnonymousIdentity ? undefined : user;
}

export var useIdentity = function useIdentity() {
  var authentication = useAuthentication();

  var _useState = useState(function () {
    return mapUser(authentication.currentUser);
  }),
      _useState2 = _slicedToArray(_useState, 2),
      currentUser = _useState2[0],
      setUser = _useState2[1];

  var refresh = useCallback(function () {
    setUser(mapUser(authentication.currentUser));
  }, [authentication]);
  useEffect(function () {
    return authentication.on('login', refresh);
  }, [authentication]);
  useEffect(function () {
    return authentication.on('logout', refresh);
  }, [authentication]);
  useEffect(function () {
    return authentication.on('expired', refresh);
  }, [authentication]);
  return currentUser;
};